import React, { useContext, useEffect, useState } from 'react';

import {
    MaterialReactTable
} from "material-react-table";
import { User2Icon } from 'lucide-react';
import { base_url } from '../../config';
import axios from 'axios';
import RegistrationContext from '../../contexts/RegistrationContext';

const Assigned = () => {
    const [data, setData] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);
    const { reload, setReload } = useContext(RegistrationContext);
    const [reloadingRow, setReloadingRow] = useState("");


    useEffect(() => {
        axios.get(`${base_url}/api/admin/get-codes/assigned`)
            .then((response) => {
                
                setData(response.data)
            })
            .catch((error) => console.error('Error fetching students:', error));
    }, []);

 


  
    const handleCopy = (code: string) => {
        navigator.clipboard.writeText(code)
            .then(() => {
                alert("Code copied to clipboard!");
            })
            .catch((error) => {
                console.error("Failed to copy code:", error);
            });
    };

    const columns = [
        {
            accessorKey: 'code',
            header: 'Code',
            
        },
        {
            accessorKey: 'name',
            header: 'Name',
            
        },
        {
            accessorKey: 'email',
            header: 'Email',
            
        }
    ];

    const handleAction = (row: any) => {

        axios.post(`${base_url}/api/admin/impersonate`,
            { id: row.code })
            .then((response) => setReload(reload + 1))
            .catch((error) => console.error('Error impersonating:', error));
    };

    return <>

        <div style={{ flex: '1 1 0', paddingBottom: '20px' }}>
            <MaterialReactTable columns={columns} data={data} />
        </div>

    </>;
};


export default Assigned;
